const CalculatorIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M17.062 1.33638C16.7091 1.33807 16.3567 1.33975 16.0051 1.33975C15.6536 1.33975 15.3012 1.33807 14.9482 1.33638C13.0465 1.32732 11.1285 1.31819 9.24648 1.57119C7.46544 1.81062 5.9913 2.31943 4.82405 3.48654C3.75387 4.5566 3.23591 5.88617 2.97289 7.47734C2.58163 9.84426 2.67732 12.2797 2.67732 14.6719V17.4363C2.67729 20.1799 2.67726 22.3743 2.90879 24.0964C3.14824 25.8775 3.65712 27.3517 4.82437 28.519C5.99161 29.6863 7.46576 30.1952 9.2468 30.4346C11.1288 30.6877 13.0468 30.6785 14.9485 30.6695H14.949C15.3018 30.6678 15.6541 30.6661 16.0055 30.6661C16.3568 30.6661 16.7091 30.6678 17.0619 30.6695H17.0624C18.9642 30.6785 20.8821 30.6877 22.7641 30.4346C24.5452 30.1952 26.0193 29.6863 27.1865 28.519C28.3538 27.3517 28.8627 25.8775 29.1021 24.0964C29.3336 22.3743 29.3336 20.1799 29.3336 17.4363V14.6719C29.3336 14.1615 29.3342 13.6762 29.3319 13.185C29.3255 10.883 29.2887 8.99768 29.0374 7.47734C28.7744 5.88617 28.2564 4.5566 27.1862 3.48654C26.019 2.31943 24.5448 1.81062 22.7638 1.57119C20.8818 1.31819 18.9638 1.32732 17.062 1.33638Z"
        fill="#0051FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6001 4.21353C8.11465 4.41323 7.29679 4.78265 6.70737 5.372C6.16467 5.91464 5.81018 6.64897 5.60127 7.91277C5.45615 8.7907 5.39136 9.85514 5.36287 11.1932C5.3548 11.5721 5.35077 11.7616 5.46838 11.8817C5.58598 12.0018 5.77689 12.0018 6.15871 12.0018H25.8484C26.2303 12.0018 26.4212 12.0018 26.5388 11.8817C26.6564 11.7616 26.6523 11.5721 26.6443 11.1932C26.6158 9.85515 26.551 8.7907 26.4059 7.91277C26.197 6.64897 25.8425 5.91464 25.2998 5.372C24.7104 4.78265 23.8925 4.41323 22.407 4.21353C20.8833 4.00869 18.8686 4.00586 16.0036 4.00586C13.1386 4.00586 11.1239 4.00869 9.6001 4.21353ZM20 6.66732C19.2636 6.66732 18.6667 7.26427 18.6667 8.00065C18.6667 8.73703 19.2636 9.33398 20 9.33398L22.6667 9.33399C23.403 9.33399 24 8.73703 24 8.00065C24 7.26427 23.403 6.66732 22.6667 6.66732L20 6.66732Z"
        fill="#0051FF"
      />
      <path
        d="M8 18.6673C8 17.9309 8.59695 17.334 9.33333 17.334H10.0351C10.7715 17.334 11.3684 17.9309 11.3684 18.6673C11.3684 19.4037 10.7715 20.0007 10.0351 20.0007H9.33333C8.59695 20.0007 8 19.4037 8 18.6673Z"
        fill="#0051FF"
      />
      <path
        d="M14.3158 18.6673C14.3158 17.9309 14.9127 17.334 15.6491 17.334H16.3509C17.0873 17.334 17.6842 17.9309 17.6842 18.6673C17.6842 19.4037 17.0873 20.0007 16.3509 20.0007H15.6491C14.9127 20.0007 14.3158 19.4037 14.3158 18.6673Z"
        fill="#0051FF"
      />
      <path
        d="M20.6316 18.6673C20.6316 17.9309 21.2285 17.334 21.9649 17.334H22.6667C23.403 17.334 24 17.9309 24 18.6673C24 19.4037 23.403 20.0007 22.6667 20.0007H21.9649C21.2285 20.0007 20.6316 19.4037 20.6316 18.6673Z"
        fill="#0051FF"
      />
      <path
        d="M9.33333 22.6673C8.59695 22.6673 8 23.2643 8 24.0007C8 24.737 8.59695 25.334 9.33333 25.334H10.0351C10.7715 25.334 11.3684 24.737 11.3684 24.0007C11.3684 23.2643 10.7715 22.6673 10.0351 22.6673H9.33333Z"
        fill="#0051FF"
      />
      <path
        d="M15.6491 22.6673C14.9127 22.6673 14.3158 23.2643 14.3158 24.0007C14.3158 24.737 14.9127 25.334 15.6491 25.334H16.3509C17.0873 25.334 17.6842 24.737 17.6842 24.0007C17.6842 23.2643 17.0873 22.6673 16.3509 22.6673H15.6491Z"
        fill="#0051FF"
      />
      <path
        d="M21.9649 22.6673C21.2285 22.6673 20.6316 23.2643 20.6316 24.0007C20.6316 24.737 21.2285 25.334 21.9649 25.334H22.6667C23.403 25.334 24 24.737 24 24.0007C24 23.2643 23.403 22.6673 22.6667 22.6673H21.9649Z"
        fill="#0051FF"
      />
    </svg>
  );
};

export default CalculatorIcon;
